<div class="common-text-input__container"
  [id]="visibility.fieldId">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--focused': visibility.showList,
      'common-text-input__container-box--error': visibility.error}"
    [attr.disabled]="visibility.noEditable?true:null"
    #containerVisibilityList>
    <div class="common-text-input__container-box-inner-list">
      <div class="common-text-input__block-header">
        <div class="common-text-input__label-no-cursor">
          <span class="common-text-input__text-label"
            [afTranslate]="'customize.visibility-conditions'">_Condiciones de visibilidad</span>
        </div>
        <div class="common-text-input__buttons-right-header">
          @if(visibility.selectedElements?.length){
            <div class="common-badge__badge-block">
              <span class="common-badge__square-md">{{visibility.selectedElements.length}}</span>
            </div>
          }
          @if(!visibility.noEditable){
            <div>
              <button class="common-button__icon-sm-noborder"
                (click)="toggleFilter($event)"
                [disabled]="concept.loadingVisibility">
                <i class="lf-icon-angle-down common-icon__md"
                  [ngClass]="visibility.showList?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
              </button>
              <p-overlayPanel #visibilityListOverlay
                styleClass="common-dropdown-list__overlay-field"
                (onShow)="visibility.showList = true"
                (onHide)="visibility.showList = false">
                <ng-template pTemplate="content">
                  <picker-visibility class="common-dropdown-list__overlay-field-list-container"
                    [ngStyle]="{'width': containerVisibilityListElement.nativeElement?.offsetWidth+'px'}"
                    [visibilityItems]="visibility.visibilityItems"
                    [selectedItems]="visibility.selectedItems"
                    [orCondition]="orCondition"
                    [itemConfigured]="itemConfigured"
                    (changeVisibility)="changeVisibility($event)">
                  </picker-visibility>
                </ng-template>
              </p-overlayPanel>
            </div>
          }
        </div>
      </div>
      <div class="common-list__list-group min-h-[22px]">
          @for (selectedElement of visibility.selectedElements; track $index) {
            <div class="common-chips__standard"
              [attr.disabled]="visibility.noEditable?true:null">
              <span-tooltip class="common-chips__label-text"
                [text]="selectedElement.text"></span-tooltip>
              @if (!visibility.noEditable){
                <button class="lf-icon-close-round common-icon__sm common-chips__icon-close"
                  (click)="deleteSelected(selectedElement)"></button>
              }
            </div>
          }
      </div>
    </div>
  </div>
</div>

